import { Platform } from 'react-native';
import isWeb from './isWeb';

const ua = (navigator && navigator.userAgent) || '';

const isIOS = isWeb
    ? ua.indexOf('like Mac OS X') > -1
    : Platform.OS === 'ios';

export default isIOS;
